import { useMemo } from "react";
import useSWR from "swr";

import { OrganizationExternalIdsResponse } from "@organization/models/OrganizationExternalIdsResponse";

import { organizationEndpoints } from "@api/Endpoints";
import { fetcher } from "@utils/swr-utils";

export function useGetOrganizationExternalIds(organizationId: string) {
  const url = organizationId
    ? organizationEndpoints.getExternalIds(organizationId)
    : null;

  const { data, error, isLoading } = useSWR<
    OrganizationExternalIdsResponse,
    Error
  >(url, fetcher);

  return useMemo(
    () => ({ externalIds: data?.externalIds, isLoading, error }),
    [data, isLoading, error]
  );
}
